import { Box } from '@chakra-ui/react';
import React from 'react';

interface NavColumnProps {
  // TODO: Consider refactoring this component with styles pulled from Template.module.scss and applied by primary/secondary boolean. -NE 20220406
  secondary?: boolean;
  className?: string;
}

const NavColumn: React.FC<NavColumnProps> = ({
  children,
  className,
  secondary,
}) => {
  return (
    <Box className={className} padding={{ base: 0, laptop: '16px' }}>
      {children}
    </Box>
  );
};

export default NavColumn;
